import { sanitize } from 'isomorphic-dompurify';

import { DynamicHeading, useFallbackTranslation } from '@gn-audio/jss-components';
import { FamilyGroup, ProductType } from '@gn-audio/jss-core';

import { StandardPriceModel } from 'api/pricesApi/pricesModel';
import { Price } from 'composables/Product/Buy/Price/Price';
import { ProductReviews } from 'composables/Product/Buy/ProductReviews';

export interface ProductInfoProps {
  group?: FamilyGroup;
  uniqueSellingPoint: string;
  price?: StandardPriceModel | null;
  isMainHeading: boolean;
}

export const ProductInfo = ({
  group,
  price,
  uniqueSellingPoint,
  isMainHeading,
}: ProductInfoProps) => {
  const { t } = useFallbackTranslation();

  const { calloutMsg, couponCalloutMessage } = price || {};
  const sanitizedMessage = sanitize(calloutMsg || couponCalloutMessage || '');

  return (
    <article className="flex flex-col items-start">
      <DynamicHeading isMainHeading={isMainHeading} className="heading-2">
        {group ? (
          <>
            {t('system.Buy')}&nbsp;{group.familyName}
          </>
        ) : (
          <div className="animate-glow text-[transparent]" aria-hidden>
            {t('system.Buy')} Jabra
          </div>
        )}
      </DynamicHeading>

      {uniqueSellingPoint && (
        <div className="paragraph-large" dangerouslySetInnerHTML={{ __html: uniqueSellingPoint }} />
      )}
      <Price productType={ProductType.Product} segmentType={group?.segmentType} price={price} />
      <ProductReviews familyId={group?.familyId} />
      {sanitizedMessage && (
        <div className="info-msg mt-4">
          <div dangerouslySetInnerHTML={{ __html: sanitizedMessage }} />
        </div>
      )}
    </article>
  );
};
